import { css, html, LitElement } from "lit"
import "../connexion/Connexion.js"

export default class MenuHamburger extends LitElement {
  static properties = {
    _estMenuOuvert: { type: Boolean, state: true },
  }

  static styles = css`
    :host {
      display: block;
      --nav-bg: light-dark(oklch(0.5907 0.1895 26.06), #333);
color: var(--couleur-texte);
    }

    nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: var(--nav-bg);
      padding: 1rem;
      color: var(--nav-color);
      position: relative;
      z-index: 1201;
      border-radius: 10px;
    }

    /* Le bouton Hamburger (caché sur desktop) */
    .menu-toggle {
      display: none;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 2rem;
      color: white;
      position: relative;
      z-index: 1202;
    }

    /* Conteneur des groupes de liens */
    .conteneurLiensNavigation {
      display: flex;
      gap: 1.7rem;
      align-items: center;
      z-index: 1000;
    }

    /* Liens du menu */
    .LiensNavigation {
      display: flex;
      gap: 1.7rem;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .LiensNavigationBas {
      margin-top: auto;
    }

    .LiensNavigation a {
      color: white;
      text-decoration: none;
    }

    .backdrop {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      pointer-events: none;
      z-index: 1200;
    }

    .backdrop.open {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    /* Version Mobile (Responsive) */
    @media (max-width: 768px) {
        nav {
            border-radius: 10px;
        }

      .backdrop {
        display: block;
      }

      .menu-toggle {
        display: block;
      }

      .conteneurLiensNavigation {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        left: 0;
        width: 50%;
        height: 100dvh;
        font-size: 2rem;
        background: var(--nav-bg);
        border-radius: 0 10px 10px 0;
        padding: 5rem 1rem 1rem;
        box-sizing: border-box;
        max-height: 0;
        overflow: hidden;
        visibility: hidden;
        opacity: 0;
        transform: translateX(-50px);
        transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease;
        pointer-events: none;
        z-index: 1201;
      }

      .LiensNavigation {
        flex-direction: column;
        gap: 30px;
        width: 100%;
      }

      .LiensNavigationBas {
        padding-bottom: 2rem;
      }

      .LiensNavigation a {
        width: 100%;
      }

      /* Quand la classe 'open' est ajoutée */
      .conteneurLiensNavigation.open {
        max-height: 100dvh;
        height: 100dvh;
        overflow-y: auto;
        visibility: visible;
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
      }

      #ma-recherche {
        border-top: 2px solid white;
        padding-top: 2.5rem;
      }
    }
    `

  constructor() {
    super()

    this._estMenuOuvert = false
  }

  render() {
    return html`
        <div class="backdrop ${this._estMenuOuvert ? "open" : ""}" @click=${this._toggleMenu}></div>
        <nav>
        <button class="menu-toggle" @click=${this._toggleMenu} aria-label="${this._estMenuOuvert ? "Fermer le menu" : "Ouvrir le menu"}" aria-expanded="${this._estMenuOuvert}">
          ${this._estMenuOuvert ? "✕" : "☰"}
        </button>

        <div class="conteneurLiensNavigation ${this._estMenuOuvert ? "open" : ""}">
          <ul class="LiensNavigation">
            <li><a href="/" @click=${this._fermerMenuSiMobile}>Accueil</a></li>
            <li><a href="/comment-ca-marche" @click=${this._fermerMenuSiMobile}>Comment ça marche ?</a></li>
            <li><a href="/blog" @click=${this._fermerMenuSiMobile}>Blog</a></li>
          </ul>

          <ul class="LiensNavigation LiensNavigationBas">
            <li><a href="/ressources-utiles" @click=${this._fermerMenuSiMobile}>Ressources utiles</a></li>
            <li><a href="/faq" @click=${this._fermerMenuSiMobile}>FAQ</a></li>
            <li><a href="/contact" @click=${this._fermerMenuSiMobile}>Contact</a></li>
            <li><a href="/a-propos" @click=${this._fermerMenuSiMobile}>À propos</a></li>
          </ul>
        </div>
        <p-connexion></p-connexion>
      </nav>`
  }

  _toggleMenu() {
    this._estMenuOuvert = !this._estMenuOuvert
  }

  _fermerMenuSiMobile() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches
    if (isMobile) {
      this._estMenuOuvert = false
    }
  }
}
customElements.define("p-menu-hamburger", MenuHamburger)
